Ext.define('SA.CrosstabHeaderCellsCache', {
    extend: 'SA.CellsCache',

    constructor({top} = {}) {
        this.callParent();

        this.top = top;
        this.trimmer = new SA.CrosstabHeaderLabelTrimmer({top});
    },

    createCell({el}) {
        return new SA.CrosstabHeaderCell({el, trimmer: this.trimmer, top: this.top});
    }
});